import { Injectable } from '@angular/core';
import { BcNotification } from 'components/notification-bar/notification';
import { NotificationType } from 'common/common/constants/notification-type.enum';
import { findIndex } from 'lodash';

type OnChangedCallback = () => void;

interface AddNotificationOptions {
  readonly id: string;
  readonly type?: NotificationType;
  readonly content?: string;
  readonly isClosable?: boolean;
  readonly autoCloseMillis?: number;
}

@Injectable()
export class NotificationBarService {
  private readonly notificationList: BcNotification[] = [];
  private onChangedCallback: OnChangedCallback = () => {
  };

  public getNotifications(): BcNotification[] {
    return this.notificationList;
  }

  public addNotification({ id, type = NotificationType.Error, content, isClosable = true, autoCloseMillis }: AddNotificationOptions): void {
    if (!this._hasNotification(id)) {
      this.notificationList.unshift({ id, type, content, isClosable });
      this.onChangedCallback();

      if (autoCloseMillis) {
        setTimeout(() => this.removeNotification(id), autoCloseMillis);
      }
    }
  }

  public removeNotification(id: string): void {
    const index = this._findNotificationIndexById(id);
    if (index >= 0) {
      this.notificationList.splice(index, 1);
      this.onChangedCallback();
    }
  }

  public setOnChangedCallback(callback: OnChangedCallback): void {
    this.onChangedCallback = callback;
  }

  private _findNotificationIndexById(id: string): number {
    return findIndex(this.notificationList, { id });
  }

  private _hasNotification(id: string): boolean {
    return this._findNotificationIndexById(id) > -1;
  }
}
